import { JarvisWebHttpClient } from '@jarvis/web-http'
import { getPswApiStack } from '../utils'

class PSWApiClient {
  constructor(stack, clientId) {
    ;(this.jarvisWebHttpInstance = new JarvisWebHttpClient()),
      (this.stack = stack),
      (this.clientId = clientId)
  }

  /**
   * @param {string} endpoint
   * @returns {string}
   */
  _buildApiUrl(endpoint) {
    return `${getPswApiStack(this.stack)}${endpoint}`
  }

  /**
   * @param {string} url
   * @returns {Promise<any>}
   */
  async _getClient(url) {
    return await this.jarvisWebHttpInstance.get({
      url,
      headers: {
        'x-hp-client-id': this.clientId
      }
    })
  }

  /**
   * @param {string} query
   * @returns {Promise<any>}
   */
  async searchDevices(query) {
    const apiUrl = this._buildApiUrl(`/api/v1/typeahead?query=${query}`)
    const response = await this._getClient(apiUrl)
    return response
  }

  /**
   * @param {{ sku: string }} sku
   * @returns {Promise<any>}
   */
  async fetchBasicDrivers({ sku }) {
    const apiUrl = this._buildApiUrl(`/api/v1/software/${sku}`)
    const response = await this._getClient(apiUrl)
    return response
  }

  /**
   * @returns {Promise<any>}
   */
  async getDeviceSearchList() {
    const apiUrl = this._buildApiUrl('/api/v1/searchList')
    const response = await this._getClient(apiUrl)
    return response
  }
}

export default PSWApiClient
